module.exports = __webpack_public_path__ + "img/skyLight.f6f6dd13.png";